import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Inject, Output, PLATFORM_ID, ViewChild } from '@angular/core';
import { isPlatformBrowser, NgClass, NgIf } from '@angular/common';
import { CompanyParamsService } from 'src/app/core/services/company-params.service';
import { Utils } from 'src/app/shared/utils';
import { HeartHeaderComponent } from '../../../../../../../shared/lista-deseos/heart-header/heart-header.component';

@Component({
    selector: 'app-smartgalapagos',
    templateUrl: './smartgalapagos.component.html',
    styleUrls: ['./smartgalapagos.component.scss'],
    imports: [NgClass, NgIf, HeartHeaderComponent]
})
export class SmartgalapagosComponent implements AfterViewInit {

  @Output() public headerHeight: EventEmitter<any> = new EventEmitter();
  @ViewChild('header') headerRef!: ElementRef;

  showMenu: boolean = false;
  openAccordion: string | null = null;
  scrolled: boolean = false;

  constructor(
    public companyParamsService: CompanyParamsService,
    @Inject(PLATFORM_ID) private platformId: any
  ) { }

  ngAfterViewInit() {
    setTimeout(() => {
      var height = this.headerRef.nativeElement.offsetHeight;
      this.headerHeight.emit(height);
    }, 300);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (!isPlatformBrowser(this.platformId)) { return; }
    this.scrolled = (window.scrollY || window.pageYOffset || 0) > 8;
  }

  renderMenu() {
    this.showMenu = !this.showMenu;
    if (!this.showMenu) { this.openAccordion = null; }
  }

  toggleAccordion(key: string) {
    this.openAccordion = this.openAccordion === key ? null : key;
  }

  goFavorites() {
    const urlFavorites: any =
      this.companyParamsService.getNameUrl() +
      '/wishlist';
    Utils.openNewTab(urlFavorites);
  }

}
